import { AppBarHeight } from '../constants/common';
import useWindowSize from './useWindowSize';

const useGridHeight = () => {
  const { height } = useWindowSize();
  return height - AppBarHeight;
};

export default useGridHeight;
